import { Dispatch, SetStateAction } from 'react';

export const addMediaQueryHandlers = <T>(
  queries: string[],
  values: T[],
  defaultValue: T,
  setValue: Dispatch<SetStateAction<T>>,
) => {
  const mediaQueryLists = queries.map((q) => window.matchMedia(q));
  const getValue = () => {
    const index = mediaQueryLists.findIndex((mql) => mql.matches);
    return values?.[index] || defaultValue;
  };
  const handler = () => setValue(getValue);
  mediaQueryLists.forEach((mql) => mql.addListener(handler));
  setValue(getValue);
  return () => mediaQueryLists.forEach((mql) => mql.removeListener(handler));
};
